export const assetCategoryKeys = {
  all: ["assetCategory"] as const,
  project: (projectId: string) => [...assetCategoryKeys.all, projectId] as const,
};

export const assetKeys = {
  all: ["assets"] as const,
  project: (projectId: string, variantId: string) => [...assetKeys.all, "project", projectId, variantId] as const,
};
